(() => {
  'use-strict';

  /**
   * A simple responsive data table
   */
  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;

      const ths = element.querySelectorAll('thead th');
      const trs = element.querySelectorAll('tbody tr');

      // create wrapper container
      const wrapper = document.createElement('div');
      wrapper.classList.add('Table-wrapper');
      // insert wrapper before el in the DOM tree
      element.parentNode.insertBefore(wrapper, element);
      // move el into wrapper
      wrapper.appendChild(element);

      if (!ths.length) {
        return; // no th existing => don't need to do next code
      }

      trs.forEach((tr) => {
        const tds = tr.querySelectorAll('td');
        const th = tr.querySelector('th'); // select if first th exist
        const deltaTh = th !== null ? 1 : 0;

        for (let i = 0; i < tds.length; i += 1) {
          if (ths[i + deltaTh] && !['', ' ', ' ', '&nbsp;'].includes(ths[i + deltaTh].innerText)) {
            tds[i].dataset.label = ths[i + deltaTh].innerText;
            element.classList.add('-hasLabels');
          } else {
            tds[i].dataset.label = '';
          }
        }
      });
    });
  }

  Drupal.behaviors.responsiveDataTable = {
    attach: () => {
      const elements = document.querySelectorAll('.text-formatted table');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
})();
